const FooterData = {

    copyright: "Copyright © 2020. All Rights Reserved To Avicom Ky",

}


export default FooterData
